module.exports = new __parcel__URL__("magnifying_glass_error.cbb1b3dd.svg").toString();